import Vue from 'vue'
import vuetify from './plugins/vuetify' // path to vuetify export
import 'vuetify/dist/vuetify.min.css'
import App from './App.vue'
import router from './router'
import store from './store'
import ApiService from './common/api.service'
import 'nprogress/nprogress.css'
import './index.css'

Vue.config.productionTip = false
ApiService.init()

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
